import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { getOrganizations, fetchOrganizations } from 'ducks/organizations'

import { getApp, getLastApp } from 'ducks/apps'
import {
  showModal,
  hideModal,
  getModalVisible,
  getAnnualToggle,
  fetchSubscription,
  cancelSubscription,
  getSubscription,
  setAnnualFlag,
  setUpdateCardFlag,
  setUpdatePaymentSettingsFlag,
  getUpdatePaymentSettingsFlag,
  setPaymentRouteType,
  setPlanSelectedFlag,
  setSelectedPlanValue,
  setSwitchToYearlyFlag,
  reset,
  getSwitchToYearlyFlag,
} from 'ducks/trialWarning'

import { formatDate } from 'utils/datetime'
import TrialBanner from './TrialBanner'
import TrialModal from './TrialModal'
import Button from '../Button'
import '../../Settings/Billing/Billing.scss'
import { requestApp } from '../../../utils/io'
import logo from '../Icon/icons/money-mouth-face.png'
import history from '../../../history'

class TrialWarning extends Component {
  state = {
    formVisible: false,
  }

  fetchData = async () => {
    const { fetchOrganizations, match } = this.props
    const { appId } = match.params
    await requestApp(appId)
    fetchOrganizations()
  }

  getOrganization = () => {
    const { organizations, app } = this.props

    if (app && app.OrganizationId) {
      return organizations.filter(org => {
        return app.OrganizationId === org.id
      })[0]
    }
  }

  handleShowModal = () => {
    const { showModal, setPaymentRouteType } = this.props
    setPaymentRouteType('upgrade')
    showModal()
  }

  handleCloseModal = () => {
    const {
      match,
      hideModal,
      setPaymentRouteType,
      setPlanSelectedFlag,
      setSelectedPlanValue,
      setUpdateCardFlag,
      setUpdatePaymentSettingsFlag,
      setSwitchToYearlyFlag,
      lastAppId,
    } = this.props

    setPaymentRouteType('billing')
    setPlanSelectedFlag(false)
    setSelectedPlanValue('')
    setUpdateCardFlag(false)
    hideModal()
    setUpdatePaymentSettingsFlag(false)
    setSwitchToYearlyFlag(false)
    const appId = match.params.appId || lastAppId

    if (appId) {
      history.push(`/apps/${appId}/screens`)
    } else {
      history.push(`/`)
    }
  }

  componentDidMount() {
    const { fetchOrganizations, organizationId, fetchSubscription } = this.props
    fetchOrganizations()
    fetchSubscription(organizationId)
  }

  showPaymentSettings = () => {
    const {
      subscription,
      setAnnualFlag,
      setUpdateCardFlag,
      setUpdatePaymentSettingsFlag,
      setSelectedPlanValue,
    } = this.props

    const { planInterval, planType } = subscription

    if (planInterval === 'month') {
      setAnnualFlag(false)
    } else {
      setAnnualFlag(true)
    }

    setSelectedPlanValue(planType)
    setUpdateCardFlag(true)
    setUpdatePaymentSettingsFlag(true)
  }

  handleSwitchToYearly = () => {
    const {
      setAnnualFlag,
      setSwitchToYearlyFlag,
      subscription,
      setSelectedPlanValue,
    } = this.props

    const { planType } = subscription
    setAnnualFlag(true)
    setSwitchToYearlyFlag(true)
    setSelectedPlanValue(planType)
  }

  toggleForm = () => {
    const { formVisible } = this.state
    const { updatePaymentSettings, setUpdatePaymentSettingsFlag } = this.props

    const showForm = !(formVisible || updatePaymentSettings)
    setUpdatePaymentSettingsFlag(false)
    this.setState({ formVisible: showForm })
  }

  handleClickBackChangePlan = () => {
    const {
      setUpdateCardFlag,
      setUpdatePaymentSettingsFlag,
      setPlanSelectedFlag,
      setSelectedPlanValue,
    } = this.props

    this.setState({ formVisible: false })
    setUpdatePaymentSettingsFlag(false)
    setUpdateCardFlag(false)
    setPlanSelectedFlag(false)
    setSelectedPlanValue('')
  }

  cancelSubscription = async e => {
    const { organizationId, cancelSubscription } = this.props

    const message = [
      'Are you sure you want to deactivate your account?',
      'Your plan will be downgraded at the end of your billing cycle and you will lose access to any features not available on your new plan.',
    ]

    if (e) {
      e.preventDefault()
    }

    if (!window.confirm(message.join(' '))) {
      return
    }

    await cancelSubscription(organizationId)

    this.setState({ formVisible: false })
    await this.fetchData()
  }

  renderSummary() {
    const { subscription } = this.props

    const {
      prevBillAmount,
      nextBillAmount,
      nextBillDate,
      prevBillDate,
      cardNumber,
      planInterval,
      planType,
      planAmount,
      setToCancel,
    } = subscription

    return (
      <div className="team-settings-billing-summary">
        <h2>
          <div>
            {subscription.planType === 'business' ||
            subscription.planType === 'launch'
              ? 'Business Plan'
              : 'Pro Plan'}
          </div>
        </h2>
        {prevBillAmount !== '0.00' ? (
          <p className="secondary large">
            {`Your last bill for $${prevBillAmount}
          was paid on ${formatDate(prevBillDate)}.`}
          </p>
        ) : null}

        {setToCancel ? (
          <p className="secondary large">{`Your ${planInterval}ly plan will be cancelled on ${formatDate(
            nextBillDate
          )}. You will not be charged again`}</p>
        ) : nextBillAmount <= 0 ? (
          <p className="secondary large">{`Your ${planInterval}ly plan renews on ${formatDate(
            nextBillDate
          )}.
                Adjusted for your account balance, you will not be charged.`}</p>
        ) : nextBillAmount === planAmount ? (
          <p className="secondary large">{`Your ${planInterval}ly plan renews on ${formatDate(
            nextBillDate
          )},
          and the card •••• ${cardNumber} will be
              automatically charged.`}</p>
        ) : (
          <p className="secondary large">{`Your ${planInterval}ly plan renews on ${formatDate(
            nextBillDate
          )}.
          Adjusted for your account balance, the card •••• ${cardNumber} will be
              automatically charged $${nextBillAmount}`}</p>
        )}
        <div className="team-settings-billing-buttons">
          <Button secondary onClick={this.showPaymentSettings}>
            Update Payment Settings
          </Button>
          <Button secondary onClick={this.toggleForm}>
            Change Plan
          </Button>
        </div>
        {planInterval !== 'year' && (
          <div className="team-settings-annual-plan-promo">
            <div className="new-plan-pricing">
              <img src={logo} className="money-mouth-image" alt="" />
              <h2> New Yearly Pricing </h2>
            </div>
            {planType === 'pro' || planType === 'individual' ? (
              <p>
                Save 20% by switching to Pro Plan Yearly (That's a $132
                savings!)
              </p>
            ) : (
              <p>
                Save 20% by switching to Business Plan Yearly (That's a $612
                savings!)
              </p>
            )}
            <Button onClick={this.handleSwitchToYearly}>
              SWITCH TO YEARLY
            </Button>
          </div>
        )}
      </div>
    )
  }

  renderForm() {
    const { fetchOrganizations, appId, subscription, annual, organizationId } =
      this.props

    const planType = subscription?.planType || 'pro'

    return (
      <TrialModal
        onKeepOpen={this.handleShowModal}
        onClose={this.handleCloseModal}
        organizationId={organizationId}
        forceRefresh={fetchOrganizations}
        appId={appId}
        initialValues={{ plan: planType, annual }}
        onDowngrade={this.cancelSubscription}
        onClickBackChangePlan={this.handleClickBackChangePlan}
      />
    )
  }

  render() {
    const {
      appId,
      modalVisible,
      subscription,
      billing,
      updatePaymentSettings,
      switchToYearly,
      hasTeamSwitcher,
    } = this.props

    const { formVisible } = this.state

    const hasSubscription =
      subscription &&
      subscription.configured &&
      subscription.planType !== 'free'

    const organization = this.getOrganization()

    const showBanner = organization && !organization.active

    const showForm =
      !hasSubscription || formVisible || updatePaymentSettings || switchToYearly

    if (hasTeamSwitcher) {
      return (
        <div>
          {billing ? (
            <div className="team-settings-billing2">
              {showForm ? this.renderForm() : this.renderSummary()}
            </div>
          ) : (
            <div className="trial-warning">
              {showBanner && (
                <TrialBanner appId={appId} onClick={this.handleShowModal} />
              )}
              {modalVisible && this.renderForm()}
            </div>
          )}
        </div>
      )
    } else {
      return (
        <div>
          {billing ? (
            <div className="team-settings-billing">
              <p className="secondary">Account</p>
              {showForm ? this.renderForm() : this.renderSummary()}
            </div>
          ) : (
            <div className="trial-warning">
              {showBanner && (
                <TrialBanner appId={appId} onClick={this.handleShowModal} />
              )}
              {modalVisible && this.renderForm()}
            </div>
          )}
        </div>
      )
    }
  }
}

const mapStateToProps = (state, { match, organizationId }) => ({
  appId: match.params.appId,
  app: getApp(state, match.params.appId),
  lastAppId: getLastApp(state),
  organizations: getOrganizations(state),
  subscription: getSubscription(state, organizationId),
  modalVisible: getModalVisible(state),
  annual: getAnnualToggle(state),
  updatePaymentSettings: getUpdatePaymentSettingsFlag(state),
  switchToYearly: getSwitchToYearlyFlag(state),
})

const connected = connect(mapStateToProps, {
  fetchSubscription,
  cancelSubscription,
  fetchOrganizations,
  getOrganizations,
  showModal,
  hideModal,
  setAnnualFlag,
  setUpdateCardFlag,
  setUpdatePaymentSettingsFlag,
  setPaymentRouteType,
  setPlanSelectedFlag,
  setSelectedPlanValue,
  setSwitchToYearlyFlag,
  reset,
})(TrialWarning)

export default withRouter(connected)
